var exports = {
  "r": "xa15a2ab7--da31e6--body",
};

module.exports = exports;
